// extracted by mini-css-extract-plugin
export var info = "styles-module--info--1KigE";
export var info_reversed = "styles-module--info_reversed--ktGqQ";
export var jsAnimInit = "styles-module--jsAnimInit--G7apw";
export var info_media = "styles-module--info_media--2xFyN";
export var info_txt = "styles-module--info_txt--2jyvF";
export var txt_top = "styles-module--txt_top--2YAbv";
export var txt_top_suptitle = "styles-module--txt_top_suptitle--2XY_-";
export var txt_main = "styles-module--txt_main--P0nLJ";
export var txt_bot = "styles-module--txt_bot--bPkgF";